import React from 'react'
import PropTypes from 'prop-types'
import { HotStories } from '@shared/components/F1Components/EditorsPick'
import { Container } from 'react-bootstrap'
import styles from './style.module.scss'
import { GET_CATEGORY_NEWS_VIDEOS } from '@graphql/series/home.query'
import { useQuery } from '@apollo/client'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'
import dynamic from 'next/dynamic'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

const Formula1Layout = ({ children }) => {
  const { data } = useQuery(GET_CATEGORY_NEWS_VIDEOS, {
    variables:
    {
      input: {
        nLimit: 18,
        nSkip: 0,
        iCategoryId: '66226bd0c8717f761bf48525',
        eType: 'vn'
      }
    }
  })

  const { addTop, mobSm, addBottom, addLeft } = reviveAdData

  return (
    <Container className={styles.layout}>
      <div className="w-full d-none d-xl-flex justify-content-center my-3">
        <ReviveAds {...addTop} className={'my-3'}/>
      </div>
      <div className="w-full d-flex d-xl-none justify-content-center my-1">
        <ReviveAds {...mobSm} className={'my-1'}/>
      </div>
      <main>{children}</main>
      <div className="w-full d-flex d-xl-none justify-content-center my-2">
        <ReviveAds {...addLeft} className={'my-2'}/>
      </div>
      <HotStories news={data?.listSimpleCategoryArticlesVideosFront?.oArticles?.aResults.slice(3)} />
      <div className="w-full d-none d-xl-flex justify-content-center my-3">
        <ReviveAds {...addBottom} className={'my-3 text-center'}/>
      </div>
    </Container>
  )
}

Formula1Layout.propTypes = {
  children: PropTypes.any
}

export default Formula1Layout
